<template>
  <div
    :class="`rl-card ${nth ? 'reverse' : ''}`"
    :style="`${show ? 'min-height: 200px' : 'min-height:auto'}`"
  >
    <div class="mt-1">
      <h3 class="text-center rl-card-title">
        {{ data.name }} <br>
        <span style="font-size:2.3vh">
          {{ data.title}}
        </span>
      </h3>
      <p  class="text-center mb-0 pb-2">
       {{ data.description}} <br>
        <small v-if="data.subtitle"> {{ data.subtitle}}</small>
      </p>
      <div :class="`rl-card-line ${nth ? 'reverse-baar' : ''}`"></div>
      <h6 class="text-center rl-card-price mb-0 pb-0" style="font-size: 16px">
        {{ data.price }}
      </h6>
      <p class="text-center pb-0 mb-0" style="font-size: 12px"> {{ data.priceTag }}</p>
      <div :class="`rl-card-line ${nth ? 'reverse-baar' : ''}`"></div>
      <div class="mt-1 text-center">
        <router-link
          tag="button"
          :to="data.to"
          :class="`rl-card-button ${nth ? 'reverse-btn' : ''}`"
          id="membership-btn1"
        >
          Subscribe Now
        </router-link>
      </div>
      <!-- new price -->
      <!-- <div class="pb-3"></div>
      <div :class="`rl-card-line ${nth ? 'reverse-baar' : ''}`"></div>
      <h6 class="text-center rl-card-price mb-0 pb-0" style="font-size: 16px">
        {{ data.price1 }}
      </h6>
      <p class="text-center pb-0 mb-0" style="font-size: 12px"> {{ data.price1Tag }}</p>
      <div :class="`rl-card-line ${nth ? 'reverse-baar' : ''}`"></div>
      <div class="mt-1 text-center">
        <router-link
          tag="button"
          :to="data.to1"
          :class="`rl-card-button ${nth ? 'reverse-btn' : ''}`"
          id="membership-btn2"
        >
          Subscribe Now
        </router-link>
      </div> -->
    </div>
  </div>
</template>

<script>
export default {
  props: ["nth", "data", "to", "show"],
};
</script>

<style scoped lang="scss">
.rl-card {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background: var(--primary-color);
  padding: 20px 20px;
  color: var(--light);
  transition: all 0.5s ease;
  min-width: 250px;
  max-width: 300px;
  // height: 390px;
  margin-bottom: 10px;

  &-title {
    font-weight: bold;
  }
  &-price {
    font-weight: bold;
  }
  &-line {
    border-top: 2px solid var(--secondary-color);
    width: 130px;
    margin: 5px 0;
    margin: 5px auto;
  }
  &-text {
    font-size: 14px;
  }
  &-description {
    font-size: 14px;
    text-align: center;
  }
  &-button {
    background: var(--red-color);
    font-size: 14px;
    padding: 5px 10px;
    border-radius: 15px;
  }
}
.rl-card:hover {
  transform: scale(1.05);
}
.reverse {
  background: var(--red-color);
}
.reverse-btn {
  background: var(--primary-color);
}
.reverse-baar {
  border-top: 2px solid var(--primary-color);
}
</style>